import classNames from "classnames";
import { Image } from "antd";
import Chat from "../Chat/Chat.pc";
import styles from "./Recruiter.pc.module.scss";

const Recruiter = ({ dictionary, data, sessionid, jobId }) => {
  return (
    <div className={styles.recruiter}>
      <div className={styles.avatar}>
        {data.recruiter.is_online ? <span className={styles.circle}></span> : null}

        <Image src={data.recruiter.avatar} alt='' />
      </div>
      <div className={styles.info}>
        <p>
          {data.recruiter.full_name ? (
            <span className={styles.name}>{data.recruiter.full_name}</span>
          ) : null}

          {/* {data.recruiter.response_rate ? (
            <span className={styles.rateWrap}>
              <span className={styles.rate}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                  fill='none'
                >
                  <path
                    d='M8.56354 1H4.9565C4.78882 1 4.63688 1.09875 4.56878 1.25197L2.3349 6.27819C2.2102 6.55877 2.41558 6.87481 2.72262 6.87481H5.00714L3.89058 10.7828C3.84189 10.9532 4.05415 11.0748 4.17653 10.9466L9.87092 4.98104C10.1286 4.71103 9.93727 4.26378 9.564 4.26378H7.61817L8.94304 1.61404C9.08409 1.33193 8.87895 1 8.56354 1Z'
                    fill='#239FE5'
                  />
                </svg>
                {data.recruiter.reply_label}
              </span>
            </span>
          ) : null} */}
        </p>
        <p className={styles.secondRow}>
          {data.recruiter.company_name ? (
            <span className={styles.companyName}>
              {data.recruiter.job_title ? (
                <>
                  <span className={styles.jobTitle}>{data.recruiter.job_title}</span>
                  {data.recruiter.job_title && data.recruiter.company_name ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='3'
                      height='4'
                      viewBox='0 0 3 4'
                      fill='none'
                    >
                      <circle cx='1.25' cy='2' r='1.25' fill='#3B3C3C' />
                    </svg>
                  ) : null}
                </>
              ) : null}
              {data.recruiter.company_name}
            </span>
          ) : null}
        </p>
        {data.recruiter?.reply_label ? (
          <p>
            <span className={styles.activeDate}>
              {/* <svg
                xmlns='http://www.w3.org/2000/svg'
                width='6'
                height='6'
                viewBox='0 0 6 6'
                fill='none'
              >
                <circle cx='3' cy='3' r='3' fill='#E4E4E4' />
              </svg> */}
              {data.recruiter?.reply_label}
            </span>
          </p>
        ) : null}
      </div>
      <div style={{ alignSelf: "center" }}>
        <Chat
          data={{
            ...data.job_header,
            ...data.job_description
          }}
          jobId={jobId}
          sessionid={sessionid}
          chatText={dictionary?.recruiter?.chat}
        />
      </div>
    </div>
  );

  // return null;
};

export default Recruiter;
